import {
  Airline,
  Airport,
  MyTripsFilter,
  PackageItinerary,
  PackageItineraryResponse,
} from "redmond";
import { call, put, select } from "redux-saga/effects";
import { fetchPackages } from "../../../api/v1/itinerary/fetchPackages";
import { actions } from "../actions";
import {
  getAirlinesMap,
  getAirportMap,
  getPackages,
  shouldExcludeCorporateTripsSelector,
} from "../reducer";
import { getIsCorporateForHotel } from "../utils";
import { setUpMyTripsParams } from "./setUpTripsParams";

export function* fetchPackagesSaga(action: actions.IFetchPackages) {
  try {
    const packagesItinerariesResponse: PackageItineraryResponse =
      yield fetchPackages(action.request);
    const { tripId } = yield call(setUpMyTripsParams, action);
    const existingPackages: { [key: string]: PackageItinerary[] } =
      yield select(getPackages);
    const {
      future = [...existingPackages.future],
      canceled = [...existingPackages.canceled],
      past = [...existingPackages.past],
      present = [...existingPackages.present],
    } = packagesItinerariesResponse.itineraries;
    let selectedPackageFilter: MyTripsFilter | null = null;
    let isFlightId = false;
    let isHotelId = false;
    let selectedPackage = null;
    const excludeCorporateTrips: boolean = yield select(
      shouldExcludeCorporateTripsSelector
    );
    const matchesTripId = (currentPackage: PackageItinerary) =>
      (currentPackage.customerConfirmationId === tripId ||
        currentPackage.flight.itinerary.bookedItinerary.id === tripId ||
        currentPackage.hotel.itinerary.reservation.reservationBookingId ===
          tripId) &&
      (!excludeCorporateTrips ||
        !getIsCorporateForHotel(currentPackage.hotel.itinerary));
    [...future, ...present].forEach((currentPackage: PackageItinerary) => {
      if (currentPackage.flight.itinerary.bookedItinerary.id === tripId) {
        isFlightId = true;
      } else if (
        currentPackage.hotel.itinerary.reservation.reservationBookingId ===
        tripId
      ) {
        isHotelId = true;
      }
      if (matchesTripId(currentPackage)) {
        selectedPackage = currentPackage;
      }
    });

    if (!selectedPackage) {
      const canceledPackage = canceled.find(matchesTripId);
      if (canceledPackage) {
        selectedPackage = canceledPackage;
        selectedPackageFilter = MyTripsFilter.CANCELED_TRIPS;
      } else {
        const pastPackage = past.find(matchesTripId);
        if (pastPackage) {
          selectedPackage = pastPackage;
          selectedPackageFilter = MyTripsFilter.PAST_TRIPS;
        }
      }
      if (selectedPackage) {
        if (selectedPackage.flight.itinerary.bookedItinerary.id === tripId) {
          isFlightId = true;
        } else if (
          selectedPackage.hotel.itinerary.reservation.reservationBookingId ===
          tripId
        ) {
          isHotelId = true;
        }
      }
    }
    if (selectedPackageFilter) {
      yield put(actions.setTripsFilter(selectedPackageFilter));
      yield put(actions.populateTripQueryParams(action.history, { tripId }));
    }
    if (selectedPackage) {
      yield put(
        actions.setSelectedPackage({
          ...selectedPackage,
        }),
      );
    }
    if (isFlightId && selectedPackage) {
      yield put(
        actions.setSelectedPackageFlight(selectedPackage?.flight.itinerary),
      );
    }
    if (isHotelId && selectedPackage) {
      yield put(
        actions.setSelectedPackageHotel(selectedPackage?.hotel.itinerary),
      );
    }

    yield put(
      actions.setPackages(
        {
          present,
          canceled,
          past,
          future,
        },
        action.request.states,
      ),
    );
    const airlines: { [key: string]: Airline } = yield select(getAirlinesMap);
    const responseAirlinesMapArr = Object.keys(
      packagesItinerariesResponse.context.airlines,
    );
    for (let i = 0; i < responseAirlinesMapArr.length; i++) {
      const currentAirline = responseAirlinesMapArr[i];
      if (!airlines[responseAirlinesMapArr[i]]) {
        airlines[currentAirline] =
          packagesItinerariesResponse.context.airlines[currentAirline];
      }
    }

    const airports: { [key: string]: Airport } = yield select(getAirportMap);
    const responseAirportMapArr = Object.keys(
      packagesItinerariesResponse.context.airports,
    );
    for (let i = 0; i < responseAirportMapArr.length; i++) {
      if (!airlines[responseAirportMapArr[i]]) {
        const currentAirport = responseAirportMapArr[i];
        airports[currentAirport] =
          packagesItinerariesResponse.context.airports[currentAirport];
      }
    }
  } catch (e) {
    yield put(actions.fetchPackagesFailed(action.request));
    console.error(e);
  }
}
